module.exports = __webpack_public_path__ + "static/img/remesas.aee50ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/markers/hq/remesas.png
// module id = AgkI
// module chunks = 1